import React from "react";
import BooksNavbar from "../components/BooksNavbar";

const Concussion = () => {
  return (
    <div>
      <section
        className="relative min-h-screen bg-cover bg-center overflow-hidden"
        style={{ backgroundImage: "url('/water-colour-clouds.png')" }}
      >

        <BooksNavbar textColor="black" />

        <div className="relative z-10 min-h-screen pt-28 pb-16">

          {/* Page Title */}
          <div className="max-w-4xl mx-auto px-6 md:px-12 text-center mb-16">

            <h2
              className="text-lg md:text-xl text-[#5f6f4f] mb-4"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              LEARN ABOUT THE SCIENCE
            </h2>

            <div className="flex items-center w-full max-w-sm mb-6 mx-auto">
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
              <span className="px-4 text-[#8c8b5f] text-lg">❖</span>
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
            </div>

            <h1
              className="text-3xl md:text-5xl text-black leading-tight mb-4"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              Concussion
            </h1>

            <p
              className="text-xl md:text-2xl italic text-[#5f6f4f] leading-snug mb-6 text-center"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              When the lights stay on, but something changes
            </p>

            <div className="flex items-center w-full max-w-sm mx-auto">
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
              <span className="px-4 text-[#8c8b5f]">❖</span>
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
            </div>

          </div>

          {/* Content */}
          <div className="max-w-7xl mx-auto px-6 md:px-12">

            <div className="grid lg:grid-cols-2 gap-12 items-start">

              {/* Left Column */}
              <div className="max-w-2xl">

                <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  Most people think a concussion is obvious. A knockout. A dazed athlete
                  stumbling across a football field. A dramatic moment that everyone can
                  see. The reality is often much more subtle and often much stranger. A
                  friend forgets the punchline to a joke halfway through telling it. A
                  teacher can't find the right word in a conversation. A parent becomes
                  unusually irritable for no obvious reason. We rarely connect these small
                  changes to the seemingly minor bump on the head that happened months
                  before.
                </p>

                <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  Every year, millions of people experience concussions. Most recover
                  fully. Some don't. Yet despite decades of research, we are only now
                  managing to answer surprisingly simple questions. Why do some people
                  bounce back within days while others experience symptoms for months or
                  years? How many concussions are too many? And what is actually happening
                  inside the brain when a seemingly harmless knock leaves a lasting mark?
                </p>
              </div>

              {/* right image */}
              <div className="flex justify-center lg:justify-end">
                <img
                  src="/concussion.png"
                  alt="Concussion"
                  className="w-full max-w-[600px]"
                />
              </div>

            </div>

            {/* Full Width Text */}
            <div className="mt-2">

            <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  Perhaps the most unsettling discovery is that some of the effects of
                  concussion are not obvious to the injured person themselves. The very
                  mental skills we rely on to notice that something is wrong — attention,
                  self-awareness, planning, and judgement — can be among the first things
                  affected.
                </p>

              <p
                className="text-base text-black leading-relaxed"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                In <em>Think Before You Think</em>, you'll discover why executive
                function is often the hidden casualty of head injury, why "feeling fine"
                is not always a reliable guide to recovery, and what decades of
                neuroscience have taught us about the brain's extraordinary ability to
                adapt, compensate, and sometimes surprise us. Because when it comes to
                concussion, the most important changes are often the ones you cannot
                see.
              </p>

              {/* Creyos Test Button */}
              <div className="mt-12 text-center">
                <a
                  href="https://habstudy.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#D4AF37] text-black px-4 py-2 font-semibold"
                >
                  IF YOU'D LIKE TO TRY SOME OF THE TESTS BEHIND THE SCIENCE, CLICK HERE
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Concussion;